import React from 'react';
import { CloudinaryImage } from '../cloudinary-image';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureImage = _ref => {
  let {
    image
  } = _ref;
  if (!image) {
    return null;
  }
  return /*#__PURE__*/_jsx(CloudinaryImage, {
    ratio: "1",
    imageSetOrImage: {
      type: 'SQUARE',
      url: image.src,
      alt: image.description
    },
    sizes: 214,
    "data-id": "mega-menu_feature-image_FeatureImage_CloudinaryImage"
  });
};